import React, { useState } from 'react';
import propTypes from 'prop-types';
import { addHours, formatDistanceToNow, isPast } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import styles from './styles';

const useStyles = makeStyles(styles);

const PendingEmail = ({ pendingEmail, onResend, onCancel }) => {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);

  if (!pendingEmail) return null;

  const sentAt = new Date(pendingEmail.sentAt);
  // no date-fns suffix: a server clock slightly ahead would read "in less than a minute"
  const status = isPast(addHours(sentAt, 24))
    ? 'link expired'
    : `link sent ${formatDistanceToNow(sentAt)} ago`;

  const run = (action) => async () => {
    setBusy(true);
    try {
      await action();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={classes.root}>
      <Typography variant="body2" color="textSecondary" className={classes.text}>
        Pending: {pendingEmail.email} — {status}
      </Typography>
      {onResend && (
        <Button size="small" color="primary" disabled={busy} onClick={run(onResend)}>
          Resend
        </Button>
      )}
      {onCancel && (
        <Button size="small" color="primary" disabled={busy} onClick={run(onCancel)}>
          Cancel
        </Button>
      )}
    </div>
  );
};

PendingEmail.propTypes = {
  pendingEmail: propTypes.shape({
    email: propTypes.string.isRequired,
    sentAt: propTypes.string.isRequired,
  }),
  onResend: propTypes.func,
  onCancel: propTypes.func,
};

export default PendingEmail;
